export const objectKeys = Object.keys as <T extends object>(
	object: T
) => Array<keyof T>

export const objectValues = Object.values as <T extends object>(
	object: T
) => T[keyof T][]

export const objectEntries = Object.entries as <T extends object>(
	object: T
) => { [K in keyof T]: [K, T[K]] }[keyof T][]

export const objectFromEntries = Object.fromEntries as <
	T extends PropertyKey,
	U
>(
	entries: Iterable<readonly [T, U]>
) => { [K in T]: U }
